// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-5940d6d3]::-webkit-outer-spin-button,\ninput[data-v-5940d6d3]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-5940d6d3] {\n  -moz-appearance: textfield;\n}\n[data-v-5940d6d3] p, ul[data-v-5940d6d3], li[data-v-5940d6d3] {\n  margin: 0 !important;\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
